import React, { useContext } from 'react';
import profileImage from '../../../assets/imgs/005.png'; 
import { AuthContext } from '../../../context/AuthContext';
import './index.css'; 

const Profile = () => {
  const { user, logout } = useContext(AuthContext);
  return (
    <div className='profile'>
      <img className='profile-img' src={profileImage} alt="profile" />
      <div className='profile-text'>
        <div className='profile-text-user'>{user.nome_usuario || user.username}</div>
        <div>{user.nivel || user.role}</div>
      </div>
    </div>
  );
};

export default Profile;
